import Form, { Header, Input, Label, Select } from "../Forms/SmartForm";
import GoogleRecaptcha from "react-google-recaptcha";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Modal from "../Modal/Modal";
import countries from "../../../libs/data/countries.json";
import jobTitles from "../../../libs/data/jobTitles.json";

const ModalGate = (props) => {
  const {
    dataAttribute = "",
    modalHeaderContent = null,
    initialSubmitting = false,
    closeForm = false,
    modalGateTrigger = <></>,
    clickOpenModalEventName = "",
    clickCloseModalEventName = ""
  } = props;

  useEffect(() => {
    setIsSubmitting(initialSubmitting);
    if (closeForm) {
      setDisplayFormModal((prev) => ({
        ...prev,
        display: false
      }));
    }
  }, [initialSubmitting, closeForm]);

  const siteFullName = "Today's Clinical Lab";
  let siteKey = "";
  if (typeof localStorage !== "undefined") {
    siteKey = localStorage.getItem("recaptchaSiteKey");
  }

  const form = useRef();
  const reCaptchaRef = useRef();
  const [displayFormModal, setDisplayFormModal] = useState({
    display: false,
    error: false
  });
  const [jobTitle, setJobTitle] = useState("");
  const [disable, setDisable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(initialSubmitting);

  const buttonTimeOut = () => {
    document.getElementById("btnClick");
    const validationEmail = document.forms["form"]["email"].value;
    const validationCountry = document.forms["form"]["lmg_demo_country"].value;
    if (validationEmail && validationCountry != "") {
      setDisable(true);
    }
  };

  const openModal = () => {
    // Push datalayer event for tracking within Google Analytics (GTM)
    window.dataLayer.push({
      event: clickOpenModalEventName,
      gtmCustomClick: {
        eventCategory: "Conversion"
      }
    });

    // Display form modal
    setDisplayFormModal((prev) => ({
      ...prev,
      display: true
    }));
  };

  const closeModal = (event) => {
    event.stopPropagation();
    // Push datalayer event for tracking within Google Analytics (GTM)
    window.dataLayer.push({
      event: clickCloseModalEventName,
      gtmCustomClick: {
        eventCategory: "Conversion"
      }
    });

    // Close form modal
    setDisplayFormModal((prev) => ({
      ...prev,
      display: false
    }));
  };

  const onSubmit = async (recaptcha) => {
    const formValues = form.current.getValuesAsObject();

    setDisplayFormModal((prev) => ({
      ...prev,
      error: false
    }));

    try {
      await axios.post("/api/v2/validate-modal-form", {
        formValues,
        recaptcha
      });
      setDisable(false);
    } catch (error) {
      if (!error.response) {
        error.response = {
          data: {
            errors: [error.message]
          }
        };
      }
      const data = error.response.data;
      if (data.errors) {
        setDisplayFormModal((prev) => ({
          ...prev,
          error: data.errors.join("<br />")
        }));
        if (data.fieldErrors) form.current.setAllErrors(data.fieldErrors);
        if (data.fieldValues) form.current.setValues(data.fieldValues);
      } else {
        setDisplayFormModal((prev) => ({
          ...prev,
          error: `${error.response.status}: ${error.response.text}`
        }));
      }
    }

    props.onSubmit(formValues);
  };

  const validateRecaptcha = async (e) => {
    e.preventDefault();
    const result = await reCaptchaRef.current.executeAsync();
    onSubmit(result);
  };

  const ModalForm = () => {
    return (
      <Modal>
        <div className="modal-gate">
          <div className="modal-gate-content m-0">
            <button
              type="button"
              className="close-btn corner background-transparent no-border text-white float-right"
              onClick={(e) => closeModal(e)}
            >
              <i className="fas fa-times fa-lg" />
            </button>
            <Header className="p-v-1 p-h-2 m-b-0 text-center">{modalHeaderContent()}</Header>
            <Form
              id="gate-form"
              className="p-v-1 p-h-2"
              onSubmit={validateRecaptcha}
              contextRef={form}
              defaults={{ country: "CA" }}
              name="form"
            >
              {displayFormModal.error && (
                <div className="alert italic">
                  <p>{displayFormModal.error}</p>
                </div>
              )}
              <div className="form-row two-items">
                <div className="form-group">
                  <Label input="firstname">First Name</Label>
                  <Input
                    type="text"
                    name="firstname"
                    label="First Name"
                    className="form-control border-light-grey m-b-1"
                  />
                </div>
                <div className="form-group">
                  <Label input="lastname">Last Name</Label>
                  <Input
                    type="text"
                    name="lastname"
                    label="Last Name"
                    className="form-control border-light-grey m-b-1"
                  />
                </div>
              </div>
              <Label input="email" required>
                Email Address
              </Label>
              <Input
                type="email"
                name="email"
                label="Email Address"
                className="form-control border-light-grey m-b-1"
                required
              />
              <Label input="lmg_demo_country" required>
                Country
              </Label>
              <Select name="lmg_demo_country" className="m-b-1 border-light-grey" label="Country" required>
                <option hidden value="">
                  Select
                </option>
                {countries.map(({ name, code }) => (
                  <option key={code} value={code}>
                    {name}
                  </option>
                ))}
              </Select>
              <div className={"form-row" + (jobTitle == "Other" && " two-items")}>
                {/** Only if user select "Other", we would then show Other text field for job title*/}
                <div className="form-group">
                  <Label input="demo_job_title">Job Title</Label>
                  <Select
                    name="demo_job_title"
                    label="demo_job_title"
                    className="m-b-1 border-light-grey"
                    onChange={(event) => setJobTitle(event.target.value)}
                  >
                    <option hidden value="">
                      Select
                    </option>
                    {jobTitles.map((jobTitle) => (
                      <option key={jobTitle} value={jobTitle}>
                        {jobTitle}
                      </option>
                    ))}
                  </Select>
                </div>
                {jobTitle == "Other" && (
                  <div className="form-group">
                    <Label input="demo_job_title_other">Other</Label>
                    <Input
                      type="text"
                      name="demo_job_title_other"
                      label="Other"
                      className="form-control border-light-grey m-b-1"
                    />
                  </div>
                )}
              </div>
              <Input type="hidden" name="implied_consent_confirmed_clm" value="Yes" />
              {modalGateTrigger({
                type: "submit",
                id: "btnClick",
                dataAttribute: dataAttribute,
                onClick: () => setTimeout(buttonTimeOut, 100),
                disabled: disable,
                isSubmitting: isSubmitting
              })}
              <button className="close-btn in-form no-border" onClick={closeModal}>
                Cancel
              </button>
              <GoogleRecaptcha ref={reCaptchaRef} sitekey={siteKey} size="invisible" />
            </Form>
            <div className="form-footer background-white text-center p-v-1 p-h-2">
              <p className="m-0">
                By submitting your email address, you agree to receive email communications related to{" "}
                <i>{siteFullName}'s</i> content, products, or our partners. You may unsubscribe from these
                communications at any time, as we respect your privacy. View our{" "}
                <a href="/privacy-policy">Privacy Policy</a> for more information.
              </p>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <div id="ModalGate">
      {displayFormModal.display && ModalForm()}
      {modalGateTrigger({ dataAttribute, onClick: openModal })}
    </div>
  );
};

export default ModalGate;
